export default __webpack_public_path__ + "static/media/loginillu3.cf3069e3.svg";